import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { emptyArr } from '@beef/utils';
import { createSelector } from '@reduxjs/toolkit';
import { getCurrentDevices, getDeviceType } from "./selectors";
import { composeTwoDeviceData } from "./utils";
export var getDeviceCompareInfoByType = createSelector([getDeviceType, getCurrentDevices], function (type, devices) {
  return devices.filter(function (device) {
    return device.type === type;
  });
});
export var getDeviceParameters = createSelector([getDeviceCompareInfoByType], function (devices) {
  if (devices.length > 1) {
    var _devices$map = devices.map(function (device) {
        return _toConsumableArray(device.deviceParameters);
      }),
      _devices$map2 = _slicedToArray(_devices$map, 2),
      firstDevice = _devices$map2[0],
      secondDevice = _devices$map2[1];
    return firstDevice.map(function (device, index) {
      var _secondDevice$index;
      return {
        items: composeTwoDeviceData(device.items, ((_secondDevice$index = secondDevice[index]) === null || _secondDevice$index === void 0 ? void 0 : _secondDevice$index.items) || emptyArr),
        title: device.title
      };
    });
  }
  return devices.map(function (device) {
    return _toConsumableArray(device.deviceParameters);
  });
});